<template>
  <div class="index-page"> 
    <div class="index-content">
      <MenuBanner/>
      <FixedSidebar/>
      
      <!-- 左侧悬浮 AI 推荐榜单 -->
      <div class="floating-left-sidebar">
        <ProductCard 
          title="AI推荐榜单" 
          sortField="salesCount" 
          sortOrder="desc"
          :pageSize="6" 
          :showPagination="false"
          mode="sidebar"
        />
      </div>

      <!-- 主内容展示区 -->
      <div class="main-sections">
        <!-- 近期上新 -->
        <div class="section-wrapper">
          <ProductCard 
            title="近期上新" 
            sortField="createdTime" 
            sortOrder="desc"
            :pageSize="12" 
            :showPagination="false"
          />
        </div>
        <!-- 热卖榜单 -->
        <div class="section-wrapper">
          <ProductCard 
            title="热卖榜单" 
            sortField="salesCount" 
            sortOrder="desc"
            :pageSize="12" 
            :showPagination="false"
          />
        </div>
        <!-- 全部商品 -->
        <div class="section-wrapper">
          <ProductCard 
            title="全部商品" 
            :pageSize="12" 
            :showPagination="false"
            :isAllProducts="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MenuBanner from '../components/MenuBanner'
import ProductCard from '../components/ProductCard'
import FixedSidebar from '../components/FixedSidebar'
export default {
  data() {
    return {
    
    }
  },
  components: { 
    MenuBanner,
    ProductCard,
    FixedSidebar
  }
}
</script>

<style lang="less">
  .index-page {
    background: radial-gradient(1200px 600px at 20% 0%, rgba(0, 212, 255, 0.2), transparent 60%),
      radial-gradient(900px 500px at 80% 10%, rgba(255, 123, 213, 0.18), transparent 55%),
      linear-gradient(180deg, #f3f6ff 0%, #f8fbff 55%, #f1f5ff 100%);
    padding-bottom: 40px;
  .index-content {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 10px;
    box-sizing: border-box;
    position: relative;
  }

  .floating-left-sidebar {
    position: fixed;
    top: 180px;
    left: 50%;
    transform: translateX(-50%);
    margin-left: calc(-700px - 150px); /* 居中位置减去 1400/2 再减去侧边栏与内容的间距 */
    width: 260px;
    z-index: 9; /* 降低 z-index，确保不遮挡菜单（菜单 z-index 为 10-11） */
    transition: all 0.3s ease;

    @media screen and (max-width: 1960px) {
      /* 当屏幕宽度不足以在左侧完整显示时，稍微向左靠拢 */
      margin-left: calc(-700px - 100px);
    }

    @media screen and (max-width: 1700px) {
      /* 屏幕变小时缩小侧边栏宽度 */
      width: 180px;
      margin-left: calc(-700px - 80px);
    }

    @media screen and (max-width: 1400px) {
      /* 屏幕更小时进一步缩小，移到最左侧但不遮挡菜单 */
      width: 140px;
      left: 10px;
      transform: none;
      margin-left: 0;
    }

    @media screen and (max-width: 1200px) {
      /* 屏幕过小时隐藏左侧侧边栏 */
      display: none;
    }
  }

  .main-sections {
    width: 100%;
  } 
    .section-wrapper {
      margin-top: 30px;
      background: rgba(255, 255, 255, 0.5);
      border-radius: 16px;
      padding: 20px;
      box-shadow: 0 8px 32px rgba(108, 123, 255, 0.05);
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.3);
      box-sizing: border-box;
      
      &.sidebar-section {
        position: sticky;
        top: 20px;
      }
    }

    .gray-page {
      display: flex;
      flex-direction: column;
      width: 100%;
      height: auto;
      background-color: #f5f5f5;
    }
  }
</style>
